export const DATA_DICTIONARY_BASKET_ADD = 'DATA_DICTIONARY_BASKET_ADD';
export const DATA_DICTIONARY_BASKET_ADD_MANY = 'DATA_DICTIONARY_BASKET_ADD_MANY';
export const DATA_DICTIONARY_BASKET_REMOVE = 'DATA_DICTIONARY_BASKET_REMOVE';
export const DATA_DICTIONARY_BASKET_CLEAR = 'DATA_DICTIONARY_BASKET_CLEAR';

// One basket per browser: pinned fields survive navigation and reloads.
export const DATA_DICTIONARY_BASKET_STORAGE_KEY = 'elements.dataDictionary.basket';
